var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-greeting"},[_c('MarkdownItVue',{attrs:{"content":_vm.content},on:{"render-complete":function($event){return _vm.$emit('completed')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }